document.addEventListener("DOMContentLoaded", function() {
    var button = document.getElementById('ProductSubmitButton-template--17605082480817__main');
    var productHandle = window.location.pathname.split("/").pop(); // gets product handle from URL

    // Replace 'specific-product-handle' with the actual handle of your product
    if (button && productHandle === '2024-fall-into-rotary-park-sponsorships') {
        button.innerText = 'DONATE';
    }
});